import { call, put, takeLatest } from 'redux-saga/effects';
import { registerReferrerSuccess, registerReferrerFailure } from './actions';
import { registerReferrerApi } from './api';
import { REGISTER_REFERRER } from './constants';

export function* performRegister(action) {
	try {
		const result = yield call(registerReferrerApi, action.data);
		yield put(registerReferrerSuccess(result.data));
	} catch (err) {
		let msg = 'Registration failed';
		if (err.response && err.response.data && err.response.data.error) {
			msg = err.response.data.error;
		}
		yield put(registerReferrerFailure(msg));
	}
}

export default function* referrerSignUpSaga() {
	yield takeLatest(REGISTER_REFERRER, performRegister);
}
